// extracted by mini-css-extract-plugin
export default {"notificationIcon":"t_bR","newNotification":"t_bS","notificationOuter":"t_bT"};